<template>
    <div class="container-download">
        <br />
        <p class="download-title">GENEasso - {{ $route.query.type }} &nbsp;&nbsp;<a :href="'/api/download/static/' + $route.query.type + '.download.txt'" target="_blank" >Download</a></p>
        <el-table
            :data="tableData"
            style="width: 100%">
            <el-table-column
                v-for="column in headerList"
                :prop="column"
                :label="column"
                width="180">
            </el-table-column>
        </el-table>
        <br/>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next"
            :total="total">
        </el-pagination>
        <br/>
    </div>
</template>

<script>
const options = new Array(30).fill(1).map((v, i) => {
    return {
        label: i,
        value: i,
    };
});
const downloadList = [
    {
        description: "Publications Information",
        details: "All publications information collected in the GENEasso",
        format: "tab separated file",
        size: "135K",
        downloadUrl: "",
    },
    {
        description: "Gene-level rare variants association",
        details: "All traits ontology information involved in the GENEasso",
        format: "tab separated file",
        size: "1.5M",
        downloadUrl: "",
    },
    {
        description: "Variant-level rare variants association",
        details: "All rare variant-disease associations at gene-level",
        format: "tab separated file",
        size: "33.1M",
        downloadUrl: "",
    },
    {
        description: "",
        details: "All rare variant-disease associations at variant-level",
        format: "tab separated file",
        size: "11.6M",
        downloadUrl: "",
    },
];

export default {
    name: "downloads",

    data() {
        return {
            options,
            downloadList: [],
            downloadId: "",
            downloadOption: [],
            tableData: [],
            headerList: [],
            pageNum: 1,
            pageSize: 10,
            total: 0
        };
    },

    created() {
        this.getDownloadData();
        this.getData();
    },

    watch: {
        '$route.query.type': function() {
            this.getData()
        }
    },

    methods: {
        async getData() {
            const type = this.$route.query.type;
            if (!type) {
                return;
            }
            let q = 'pageSize=' + this.pageSize
            if (this.pageNum) {
                q = q + '&pageNum=' + this.pageNum
            }
            let res = await this.$ajax.get("/download/dagena/" + type + '.browse.txt?' + q, {});
            this.tableData = res.data.contentList
            this.headerList = res.data.headerList
            this.pageNum = res.data.pageNum
            this.total = res.data.total
        },

        async search(val) {
            let params = {
                keyword: val,
                pageSize: 20,
            };

            let res = await this.$ajax.get("download/search", params);
            this.downloadOption = (res.data.records || []).map((v) => {
                return {
                    label: v.name,
                    value: v.downloadUrl,
                };
            });
        },

        handleCurrentChange(val) {
            this.pageNum = val
            this.getData()
        },

        handleSizeChange(val) {
            this.pageSize = val
            this.getData()
        },

        async getDownloadData() {
            let res = await this.$ajax.get("download/list");
            this.downloadList = res.data || [];
        },

        handleDownloadFile() {
            if (!this.downloadId) return;
            window.open(this.downloadId, "_blank");
        },
    },
};
</script>

<style lang="less" scoped>
.button-download {
    border-color: #176b6e;
    border-radius: 5px;
    padding: 3px 6px;
    background-color: transparent !important;
    outline: none !important;
    box-shadow: none !important;
    height: 38px;
    color: #176b6e;
    font-size: 24px;
    border-width: 2px;
    margin-left: 10px;
}

.container-download {
    width: 70%;
    margin: 0 auto;
    .download-title {
        font-size: 24px;
        color: #176b6e;
        text-align: center;
    }
}

.search-select {
    width: 100%;
    display: inline-block;
    max-width: 800px;
}

table {
    width: 100%;
    margin: 20px 0 50px;
    border-collapse: collapse;

    thead {
        th {
            padding: 5px 0;
            border-top: 2px solid #000000;
            border-bottom: 2px solid #000000;
            text-align: left;
            height: 50px;
        }
    }

    tbody {
        tr {
            td {
                height: 50px;
            }
        }
        tr:last-child td {
            padding: 10px 0;
            border-bottom: 2px solid #000000;
            text-align: left;
        }
    }

    a {
        color: #176b6e;
    }
}
</style>
